<template>
  <div class="schoolProduct" ref="contents">
    <div class="headView">
      <!-- <p class="text">
      </p> -->
    </div>
    <div class="products">
      <div class="product" v-for="(item, index) in data" :key="item.id">
        <WorkItem :dic="item.showwork" :data-type="data_type"/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Utils } from "@/utils";
import WorkItem from '../scratch/components/WorkItem.vue'

import { types as LoginTypes } from "@/store/modules/login";
import { types as WorkTypes } from "@/store/modules/work";
import { types as ConfirmTypes } from "@/store/modules/confirm";
import { types as SchoolTypes } from "@/store/modules/school";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "SchoolProduct",
  components: {
    WorkItem
  },
  props: {},
  data() {
    return {
        school_id: 0,
        data_type: 'school_product'
    };
  },
  watch: {},
  computed: {
    ...mapState({
        page: state => state.school.product.page,
        load_more: state => state.school.product.load_more,
        data: state => state.school.product.data,
        school: state => state.school.currentSchool
    })
  },
  methods: {
    ...mapMutations({
      showConfirm: ConfirmTypes.SHOW,
      hideConfirm: ConfirmTypes.HIDE,
    }),
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchLikeWorkEvent: WorkTypes.FETCH_LIKE_EVENT,
      fetchListProduct: SchoolTypes.FETCH_PRODUCT_LIST,
      fetchCreateProductOrder: SchoolTypes.FETCH_CREATE_PRODUCT_ORDER,
      fetchRemovePorduct: SchoolTypes.FETCH_REMOVE_PRODUCT
    }),
    ...Utils,
    
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }
      
      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
         that.fetchListProduct({page: that.page + 1, school:that.school_id})
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    },

    // --------------workItem 组件回调事件
    //点赞作品
    likeWorkEvent(item) {
      let callback = () => {
      this.fetchLikeWorkEvent({pk:item.pk, data_type: this.data_type});
      }
      this.dependLoginStatus().then(callback)
    },
    //作品详情页
    jumpToWorkDetail(item) {
      let host = location.host;
      if (location.host.indexOf("develop.cxy61.com") > -1) {
        host = "app.bcjiaoyu.com";
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${item.pk}`,
        "_blank"
      );
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.workHeight = (this.$refs.contents.clientWidth - 30) / 4 - 10 - 2;
    let school_id = this.$route.params.school_id;
    this.school_id = school_id;
    this.fetchListProduct({page: 1, school:school_id})

  }
};
</script>

<style lang="less" scoped>
.schoolProduct {
  background-color: #f6f6f6;
  padding: 15px;
  .headView {
    margin-bottom: 15px;
    .text {
      color: #666666;
      font-size: 12px;
    }
  }
  .products {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: calc(100%);
    margin: auto;
    margin-left: 5px;
  }
  .product {
    background-color: #ffffff;
    border: solid 1px #ebebeb;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    width: calc(100% / 4 - 12px);
    position: relative;
    .takeoff{
      position: absolute;
      left: 0;
      top: 10px;
      padding: 2px 7px;
      padding-right: 10px;
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      background-color: #541DFF;
      color: #ffffff;
      font-size: 11px;
      cursor: pointer;
    }
    .img {
      width: 100%;
      height: 150px;
      background-color: #e1e1e1;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .text {
      padding-left: 10px;
      padding-right: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 12px;
      .name {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        .title {
          color: #2d2d2d;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          flex: 1;
          margin-right: 10px;
        }
        .sell {
          color: #666666;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
        }
      }
      .priceView {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 5px;
        margin-bottom: 10px;
        align-items: center;
        .price {
          color: #2d2d2d;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          flex: 1;
          margin-right: 10px;
        }
        .buy {
          padding: 2px 10px;
          border-radius: 15px;
          background-color: #f56501;
          color: #ffffff;
        }
        .bought{
          padding: 2px 10px;
          border-radius: 15px;
          background-color: #e1e1e1;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
